import React from "react";
import ExtraCotaFetcher from "./ExtraCotaFetcher";
import EventsScroller from "./EventsScroller";
import TopEvents from "./TopEvents";
import Img from "../../common/Img";
import LiveDataProvider from "../../live/LiveDataProvider";
import TopLive from "../top-live/TopLive";
import { getLabel } from "../../InitData";

export default function FlashOdds() {
    return (
        <>
            <div className="c_44">
                <Img className="c_44_1" src="daily_flash_odds.svg" height="16px" width="16px" />
                <div className="c_44_2">{getLabel('daily_flash_odds')}</div>
            </div>
            <ExtraCotaFetcher renderItem={(data) =>
                <>
                    {data.cota.length > 0 &&
                        <EventsScroller data={data.cota} icon={'boost_offer.svg'} title={getLabel('boost_offer')} />
                    }
                    {data.extra.length > 0 &&
                        <EventsScroller data={data.extra} icon={'extra_offer.svg'} title={getLabel('extra_offer')} />
                    }
                </>
            } />
            <TopEvents renderItem={(data) =>
                <EventsScroller data={data} icon={'top_events.svg'} title={getLabel('general.top_events')} />
            } />
            <LiveDataProvider>
                <TopLive />
            </LiveDataProvider>
        </>
    );
}
